import { render, staticRenderFns } from "./add-commodity.vue?vue&type=template&id=507207b5&scoped=true"
import script from "./add-commodity.vue?vue&type=script&lang=js"
export * from "./add-commodity.vue?vue&type=script&lang=js"
import style0 from "./add-commodity.vue?vue&type=style&index=0&id=507207b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507207b5",
  null
  
)

export default component.exports